var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgLhb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 30H39.0476V80.5967H69.0476V89.4272H30V30Z",
    fill: "#6E6F71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0464 30H93.0941V53.8663H120.951V30H129.999V89.4272H120.951V62.4582H92.856V89.4272H84.0464V30Z",
    fill: "#6E6F71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0952 108.282H30V130H43.0952V108.282Z",
    fill: "#D6DB29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4761 108.282H43.0952V130H55.4761V108.282Z",
    fill: "#4CBEC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8559 108.282H55.4749V130H67.8559V108.282Z",
    fill: "#8F4199"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2357 108.282H67.8547V130H80.2357V108.282Z",
    fill: "#F58368"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6214 108.282H80.2404V130H92.6214V108.282Z",
    fill: "#1085C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.001 108.282H92.6202V130H105.001V108.282Z",
    fill: "#F9C415"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.621 108.282H105.24V130H117.621V108.282Z",
    fill: "#9B9E92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.001 108.282H117.62V130H130.001V108.282Z",
    fill: "#F69320"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(30 30)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLhb);
export default __webpack_public_path__ + "static/media/lhb.e10aa632.svg";
export { ForwardRef as ReactComponent };